import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate
} from "react-router-dom";
import AboutUs from '../AboutUs/AboutUs';
import CreateNewPassword from '../Authentication/CreateNewPassword';
import ForgotPassword from '../Authentication/ForgotPassword';
import SignIn from '../Authentication/SignIn';
import SignUp from '../Authentication/Singup';
import BlogDetails from '../Blogs/BlogDetails';
import Checkout from '../Checkout/Checkout';
import Checkout2 from '../../Components/UpgradeSubscription/Stripes/Checkout2';
import Contact from '../ContactUs/Contact';
import HomePage from '../Home/HomePage';
import Podcast from '../Podcast/Podcast';
import SinglePodcast from '../Podcast/SinglePodcast';
import Packages from '../Packages/Packages';
import EditProfile from '../Profile/EditProfile';
import MySubscription from '../Profile/MySubscription';
import Payment from '../Profile/Payment';
import Profile from '../Profile/Profile';
import PrivacyPolicy from '../Terms&Conditions/PrivacyPolicy';
import TermsCondition from '../Terms&Conditions/TermsConditions';
import Thankyou from '../ThankYou/Thankyou';
import Thankyous from '../Thanks/Thankyous';
import Tips from '../Tips/Tips';
import TipsDetails from '../Tips/TipsDetails';
import AllBlogs from '../Blogs/AllBlogs';
import RequireAuth from './RequireAuth';
import { useSelector } from 'react-redux';
import MyInterests from '../Profile/MyInterests';
import UpdateSubscription from '../Profile/UpdateSubscription';
import VenmoRenewSubs from '../Profile/VenmoRenewSubs';
import PayPalCheckOut from '../Profile/PayPalCheckOut';

const AllRoutes = () => {

    const reduxState = useSelector((state) => state.Auth);
    // console.log('from app js page',reduxState.token);
    let isLogin = reduxState.token;



    return (
        <div>
            <BrowserRouter>
                <Routes>
                    {/* private routes starts here */}
                    <Route path="/venmo-renew"
                        element={
                            <RequireAuth>
                                <VenmoRenewSubs />
                            </RequireAuth>
                        } />
                    <Route path="/tips"
                        element={
                            <RequireAuth>
                                <Tips />
                            </RequireAuth>
                        } />
                    <Route path="/tipsdetails/:id/:category"
                        element={
                            <RequireAuth>
                                <TipsDetails />
                            </RequireAuth>
                        } />
                    <Route path="/checkout"
                        element={
                            <RequireAuth>
                                <Checkout />
                            </RequireAuth>
                        } />
                    <Route path="/ordercheckout"
                        element={
                            <RequireAuth>
                                <Checkout2 />
                            </RequireAuth>
                        } />
                    <Route path="/thankyou"
                        element={
                            <RequireAuth>
                                <Thankyou />
                            </RequireAuth>
                        } />
                    <Route path="/thank-you"
                        element={
                            <RequireAuth>
                                <Thankyous />
                            </RequireAuth>
                        } />
                    <Route path="/profile"
                        element={
                            <RequireAuth>
                                <Profile />
                            </RequireAuth>
                        } />
                    <Route path="/editprofile"
                        element={
                            <RequireAuth>
                                <EditProfile />
                            </RequireAuth>
                        } />
                    <Route path="/mysubscription"
                        element={
                            <RequireAuth>
                                <MySubscription />
                            </RequireAuth>
                        } />
                    <Route path="/subscription"
                        element={
                            <RequireAuth>
                                <UpdateSubscription />
                            </RequireAuth>
                        } />
                    <Route path="/payment"
                        element={
                            <RequireAuth>
                                <Payment />
                            </RequireAuth>
                        } />
                    <Route path="/myinterests"
                        element={
                            <RequireAuth>
                                <MyInterests />
                            </RequireAuth>
                        } />
                    {/* <Route path="/podcast"
                        element={
                            <RequireAuth>
                                <Podcast />
                            </RequireAuth>
                        } /> */}
                    {/* <Route path="/singlepodcast/:id"
                        element={
                            <RequireAuth>
                                <SinglePodcast />
                            </RequireAuth>
                        } /> */}
                    {/* <Route path="/packages"
                        element={
                            <RequireAuth>
                                <Packages />
                            </RequireAuth>
                        } /> */}
                    {/* private routes ends here */}

                    <Route path="/signin" element={<SignIn />} />
                    <Route path="/signup" element={isLogin ? <Navigate to='/' /> : <SignUp />} />
                    <Route path="/createnewpassword" element={isLogin ? <Navigate to='/' /> : <CreateNewPassword />} />
                    <Route path="/forgotpassword" element={isLogin ? <Navigate to='/' /> : <ForgotPassword />} />
                    <Route path="/aboutus" element={<AboutUs />} />
                    <Route path="/blogs" element={<AllBlogs />} />
                    <Route path="blogdetails/:id" element={<BlogDetails />} />
                    <Route path="/termsandcondition" element={<TermsCondition />} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                    <Route path="/" element={<HomePage />} />
                    <Route path="/contactus" element={<Contact />} />
                    <Route path="/packages" element={<Packages />} />
                    <Route path="/singlepodcast/:id" element={<SinglePodcast />} />
                    <Route path="/podcast" element={<Podcast />} />
                    <Route path="/paypal-checkout" element={<PayPalCheckOut />} />
                    <Route path="*" element={<HomePage />} />
                    {/* <Route path="/tips" element={<Tips />} />
                    <Route path="/tipsdetails" element={<TipsDetails />} />
                    <Route path="/podcast" element={<Podcast />} />
                    <Route path="/singlepodcast" element={<SinglePodcast />} />
                    <Route path="/packages" element={<Packages />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/thankyou" element={<Thankyou />} /> */}
                    {/* <Route path="/profile" element={<Profile />} />
                    <Route path="/editprofile" element={<EditProfile />} />
                    <Route path="/mysubscription" element={<MySubscription />} />
                    <Route path="/payment" element={<Payment />} /> */}
                </Routes>
            </BrowserRouter>
        </div>
    )
}

export default AllRoutes;